import { useState } from "react";
import ProcessFile from "./components/ProcessFile";
import Accordian from "./components/Accordian";
import FileContext, { useFileDispatch } from "./context/FileContext";
import Instructions from "./components/Instructions";
import ProjectOverview from "./components/ProjectOverview";
import Header from "./components/Header";
import Statistics from "./components/Statistics";
import PrivacyNotice from "./components/PrivacyNotice";

function App() {
  return (
    <div className="">
      <Header />

      <div className="flex flex-col items-center mt-10 px-4 mb-10 gap-6 w-full">
        <div className="w-full lg:w-[70%] mx-auto">
          <ProjectOverview />
        </div>

        <div id="demo" className="flex flex-col gap-4 w-full lg:w-[70%]">
          <Instructions />
          <PrivacyNotice />
          <FileContext>
            <div className="border border-black rounded-md p-4 bg-white shadow-xl relative">
              <h1 className="text-xl font-semibold text-[#07074D]">Project Demo</h1>
              <div className="flex flex-col gap-4">
                <Accordian />
                <hr />
                <ProcessFile />
              </div>
            </div>
            <Statistics />
          </FileContext>
        </div>
      </div>
    </div>
  );
}

export default App;
